import React, { useContext, useEffect } from 'react';
import "./modalGuiaCdc.scss";
import { useStaticQuery, graphql, navigate } from "gatsby";
import rawToReact from "../../../utils/rawToReact";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import GlobalContext from "../../../contexts/globalContext";
import { Button } from "@comfama/comfama-ui";

interface ModalProps extends React.ComponentProps<"div"> {
    children?: React.ReactNode
    showModal: boolean
    onClose: () => void
}

const ModalGuiaCdc: React.FC<ModalProps> = (props: ModalProps) => {
    const { children, showModal, onClose, ...rest } = props;
    const compClass = "cfmui-modal";

    useEffect(() => {
        document.body.style.overflow = showModal ? "hidden" : "unset";
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [showModal]);

    const modalData = useStaticQuery(graphql`
        query MODALGUIACDC {
            contentfulContactenos(contentful_id: {eq: "4hzZz5bIKSpXVelwNClBDP"}) {
            imagenesEmpleo {
                file {
                url
                }
            }
            tituloPrincipal
            tituloBoton
            redireccionBoton
            tituloBotonOpcional
            descripcion {
                raw
            }
            descripcionFormulario {
                raw
            }
            }
        }
    `);

    const {
        tituloPrincipal,
        tituloBoton,
        redireccionBoton,
        tituloBotonOpcional,
        descripcion,
        descripcionFormulario
    } = modalData.contentfulContactenos;

    const context = useContext(GlobalContext);

    const handleButtonClick = () => {
        window.open(redireccionBoton, '_blank');
        localStorage.setItem("guideCdc", 'true');
    };

    const attributes = {
        ...rest,
        className: `${rest.className || ""} ${compClass}`.trim(),
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div {...attributes}>
                <div 
                    className="modal-guiaCdc__box" 
                    onClick={(e) => e.stopPropagation()} // Prevent clicks inside modal from closing it
                >
                    <button
                        type="button"
                        className="close-button"
                        onClick={onClose}
                    />
                    <div className="modal-guiaCdc__content">
                        <h2 className="modal-guiaCdc__content__title">
                            {tituloPrincipal}
                        </h2>
                        <div className="modal-guiaCdc__content__textBox">
                            <div className="modal-guiaCdc__content__textAux1">
                                {rawToReact(descripcion.raw, contentfulRenderOptions)}
                            </div>
                            <hr/>
                            <div className="modal-guiaCdc__content__textAux2">
                                {rawToReact(descripcionFormulario.raw, contentfulRenderOptions)}
                            </div>                         
                        </div>
                        
                        <div className='modal-guiaCdc__content__buttonsBox'>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ mr: 1 }}
                                onClick={handleButtonClick}>
                                    {tituloBoton}
                            </Button>
                            <Button 
                                variant="contained"
                                size="small"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                    context.gigyaContext.loginComfamaId!();
                                }}>
                                    {tituloBotonOpcional}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalGuiaCdc;